<template>
  <sys-data-table
    :height="alturaDaJanela - 165"
    :item-height="45"
    :headers="CEBECALHOS_GRID"
    :items="CEBECALHOS_GRID.length > 0 ? produtos : []"
    ativar_ordenacao_manual
    @scroll-items="verificarFimScroll"
    @ordernar-coluna-selecionada="ordenarColuna"
  >
    <template #top>
      <div class="d-flex align-center py-3 w-full">
        <v-icon size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium text-systock-blue">Produtos</span>

        <v-divider vertical class="mx-3" />

        <ColunasTabela @update:colunas="ev => cabecalhos = ev" />

        <SysBtn class="ml-3" @click="exportarParaExcel">
          <v-icon left>$Excel</v-icon>
          Exportar
        </SysBtn>

        <v-spacer />

        <div class="w-450">
          <v-text-field
            v-model="pesquisa"
            hide-details
            dense clearable
            label="Pesquisar"
            append-icon="mdi-magnify"
            v-lazy-input:debounce="2000"
            @input="pesquisarProduto"
          />
        </div>
      </div>
    </template>

    <template #item.descricao_produto="{item}">
      <div class="d-flex align-center">
        <DetalhesProduto
          :produto="{ id_grupo: item.idgrupo, id_filial: 9999, id_produto: item.idproduto, produto_eh_combinacao: item.produto_eh_combinacao}"
          :ativar_filtro_revenda_direta="ativar_filtro_revenda_direta_detalhes_produto"
        />
        {{ item.descricao_produto }}
      </div>
    </template>
  </sys-data-table>
</template>

<script>
import ResponsiveHeight from "@/helpers/ResponsiveHeight.js";
import ColunasTabela from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/DetalhamentoDuploClique/ColunasDaTabela/Index.vue";
import {buscarDetalhamentoProdutos} from "@/api/Diagnostico/CurvasCruzadas";
import {formatarParametrosObjParaUrl, logout} from "@/helpers";
import {formatarLinhaDetalhamentoProduto} from '@/components/Diagnostico/LinhaDuplamenteClicada/FormatacaoLinha.js';
import $axios from "@/api/api";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

export default {
  name: "Tabela",
  mixins: [ResponsiveHeight],
  components: {
    ColunasTabela,
    DetalhesProduto
  },
  props: {
    filtros_basicos: Object,
    histograma: String,
    nivel_servico: String,
    idsegmento: Number,
    idfornecedor: Number,
    idproduto: String,
    idgrupo: Number,
    data: String,
    produto_combinado: Boolean,
    ativar_filtro_revenda_direta_detalhes_produto: Boolean,
  },
  data: () => ({
    cabecalhos: [],
    timer_scroll_data_table: null,
    produtos_por_pagina: 200,
    produtos: [],
    pesquisa: '',
    todos_itens_paginados_carregados: false,
    order_by: []
  }),
  computed: {
    CEBECALHOS_GRID() {
      const callback = item => ({
        ...item,
        style: {
          whiteSpace: 'nowrap',
          paddingRight: '10px'
        }
      });
      return this.cabecalhos.map(callback)
    },
    PAGINA_ATUAL_PRODUTOS() {
      return Math.ceil(this.produtos.length / this.produtos_por_pagina);
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    PARAMETROS_PRODUTOS() {
      const obj = {
        ...this.FILTROS_STORE,
        ...this.filtros_basicos,
        histogramas: this.histograma ? [this.histograma] : this.filtros_basicos.histogramas || [],
        niveis_servico: this.nivel_servico ? [this.nivel_servico] : this.filtros_basicos.niveis_servico ? this.filtros_basicos.niveis_servico : [],
        segmentos: this.idsegmento ? [this.idsegmento] : this.filtros_basicos.segmentos || [],
        fornecedores: this.idfornecedor ? [this.idfornecedor] : this.filtros_basicos.fornecedores || [],
        produtos: this.idproduto ? [this.idproduto] : this.filtros_basicos.produtos || [],
        grupos: this.idproduto ? [this.idgrupo] : this.filtros_basicos.grupos ? this.filtros_basicos.grupos : this.FILTROS_STORE.grupos,
        pesquisa: this.pesquisa,
        order_by: this.order_by,
        estoque_maior_que_zero: 'S',
        produto_combinado: this.produto_combinado ? 'S' : 'N',
      };

      if ((this.data.toLocaleLowerCase() !== 'hoje')) {
        obj.data = this.data;
      }

      return obj;
    }
  },
  mounted() {
    this.buscarProdutosDetalhamentoSlowNoMoving();
  },
  methods: {
    ordenarColuna(ev) {
      if (ev.value === this.order_by[0] && ev.order === this.order_by[1]) return;

      this.produtos = [];
      this.todos_itens_paginados_carregados = false;

      this.order_by = [ev.value, ev.order];
      this.buscarProdutosDetalhamentoSlowNoMoving();
    },
    buscarProdutosDetalhamentoSlowNoMoving() {
      if (this.todos_itens_paginados_carregados) {
        return;
      }

      const parametros = {
        ...this.PARAMETROS_PRODUTOS,
        pagina: (this.PAGINA_ATUAL_PRODUTOS + 1),
        produtos_por_pagina: this.produtos_por_pagina,
        order_by: this.order_by,
      };

      const callback_sucesso = produtos => {
        this.produtos.push(...produtos.map(formatarLinhaDetalhamentoProduto));

        if (produtos.length < this.produtos_por_pagina) {
          this.todos_itens_paginados_carregados = true;
        }
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarDetalhamentoProdutos(parametros)
          .then(callback_sucesso)
          .catch(logout)
      );
    },
    pesquisarProduto() {
      this.produtos = [];
      this.todos_itens_paginados_carregados = false;
      this.buscarProdutosDetalhamentoSlowNoMoving();
    },
    verificarFimScroll({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 100) < scrollHeight || !(this.produtos.length > 0)) return;
      clearTimeout(this.timer_scroll_data_table);
      this.timer_scroll_data_table = setTimeout(() => this.buscarProdutosDetalhamentoSlowNoMoving(), 500);
    },
    exportarParaExcel() {
      const parametros = formatarParametrosObjParaUrl(this.PARAMETROS_PRODUTOS);
      const url = `${$axios.defaults.baseURL}/relatorios/diagnostico/produtos/exportacao-excel${parametros}`
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>

</style>
